import { faBan, faCarOn, faFileImport, faUpload, faWrench } from "@fortawesome/pro-solid-svg-icons"
import { Box, Container, Grid, Typography } from "@mui/material"
import { hasRole } from "auth/hasRole"
import { useApi } from "auth/useApi3"
import { AppContext } from "components/AppContextProvider"

import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import PaperBox from "components/PaperBox"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoles } from "generated/roles"
import { allRoutes } from "generated/routes"
import { useContext, useEffect } from "react"
import { DashboardCard } from "./DashboardCard/DashboardCard"
import NoDataCard from "./DashboardNoDataCard"
import { DashboardQuickLinks } from "./DashboardQuickLinks"
import { useTranslation } from "react-i18next"

const Dashboard = () => {
  const { t } = useTranslation()
  const loadingContext = useContext(GlobalLoaderContext)
  const [dashboardResult, dashboardFuncs] = useApi([])
  const [dashboardVtrResult, dashboardVtrFuncs] = useApi([])
  const appContext = useContext(AppContext)
  const isVehicleRegistryAdmin = hasRole(appContext.appUser, allRoles.VehicleRegistryAdmin)

  useEffect(() => {
    dashboardFuncs.get(apiEndpoints.vehicleregistry.getdashboard)
    dashboardVtrFuncs.get(apiEndpoints.vehicleregistry.getvtrfordashboard)
    return () => {
      dashboardFuncs.leave()
      dashboardVtrFuncs.leave()
    }
  }, [dashboardFuncs, dashboardVtrFuncs])

  useEffect(() => {
    loadingContext.setLoading(() => dashboardResult.status === 1)
  })

  return (
    <>
      <Container>
        <Grid
          spacing={2}
          container
          direction="row"
          justifyContent="spaceBetween"
          sx={{ display: { xs: "block", md: "flex" } }}>
          <Grid item md={8} lg={9} direction="column">
            <Box mb={5}>
              <Typography variant="h1">{t("global.your_vehicles", "Your vehicles")}</Typography>
            </Box>
            <>
              {dashboardResult.status === 2 && dashboardResult.data.totalVehicles < 0 ? <NoDataCard /> : null}
              <Grid container spacing={2}>
                <DashboardCard
                  icon={faUpload}
                  route={allRoutes.VehicleregistryVehicles}
                  itemLength={dashboardResult.data?.totalVehicles}
                  title={t("vehicleregistry.posted_vehicles", "Posted vehicles")}
                  quantityType={t("global.pc", "pcs")}
                  status={dashboardResult.status}
                />

                <>
                  {/*<DashboardCard*/}
                  {/*  icon={faBan}*/}
                  {/*  route={`${allRoutes.VehicleregistryVehicles()}?brukandeförbud=Ja`}*/}
                  {/*  itemLength={dashboardResult.data?.totalKorforbud}*/}
                  {/*  title={t("vehicleregistry.driving_ban", "Driving ban")}*/}
                  {/*  quantityType={t("global.pc", "pcs")}*/}
                  {/*  status={dashboardResult.status}*/}
                  {/*/>*/}
                  {/*<DashboardCard*/}
                  {/*  icon={faWrench}*/}
                  {/*  route={`${allRoutes.VehicleregistryVehicles()}?besiktningInom14Dagar=Ja`}*/}
                  {/*  itemLength={dashboardResult.data?.totalBesiktningInom14Dagar}*/}
                  {/*  title={t("vehicleregistry.inspection_within_14_days", "Inspection within 14 days")}*/}
                  {/*  quantityType={t("global.pc", "pcs")}*/}
                  {/*  status={dashboardResult.status}*/}
                  {/*/>*/}
                </>
                {isVehicleRegistryAdmin && (
                  <DashboardCard
                    icon={faFileImport}
                    route={allRoutes.VehicleregistryVehiclesImportvtr()}
                    itemLength={dashboardVtrResult.data}
                    title={t("global.import_from_the_transport_agency", "Import from the Transport Agency")}
                    quantityType={t("global.pc", "pcs")}
                    status={dashboardVtrResult.status}
                  />
                )}
                <DashboardCard
                  icon={faCarOn}
                  route={allRoutes.IssuereportsArchive()}
                  itemLength={dashboardResult.data?.totalIssueReports}
                  title={t("global.issuereports", "Issue reports")}
                  quantityType={t("global.pc", "pcs")}
                  status={dashboardResult.status}
                />
              </Grid>
            </>
          </Grid>
          <Grid item md={4} lg={3} mt={{ xs: 5, md: 0 }}>
            <Box mb={{ xs: 2, md: 5 }}>
              <Typography variant="h4">{t("global.quick_links", "Quick links")}</Typography>
            </Box>
            <PaperBox mt={0}>
              <DashboardQuickLinks />
            </PaperBox>
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
export default Dashboard
